import { useMemo } from 'react'

import {
    useSearch,
    useSiteLinkSelection,
    useSortedData,
} from '@/features/analytics/hooks'
import { transformLinksToTableFormatSites } from '@/features/analytics/types'
import {
    SiteLinkWithAnalyticsType,
    useUpdateSiteLinkMutation,
} from '@/shared/api'
import { useMarkingStatus } from '@/shared/hooks'
import { TableLoadingIndicator } from '@/shared/ui/loading-indicator/LoadingIndicator'
import {
    useActiveUser,
    AdvertiserAccount,
    Site,
} from '@/true-fsd/data/advertiser-account'

import '../inviteLinksTable.scss'
import { useEditSingleField } from '../shared/hooks'
import { ScrollableTable } from '../shared/ScrollableTable'

import { TableHeadRow } from './TableHeadRow'
import { TableRow } from './TableRow'

const useSkipColumns = () => {
    // const shouldShowOrd = useGetFeatureFlagByKey('ord', user.user_id)
    const skipColumns = useMemo(() => ({ marking: false }), [])

    return { skipColumns }
}

const useTableRows = (siteLinks: SiteLinkWithAnalyticsType[]) => {
    const formattedRows = useMemo(() => {
        return transformLinksToTableFormatSites(siteLinks)
    }, [siteLinks])

    const { filteredData, searchQuery, setSearchQuery } =
        useSearch(formattedRows)
    const { sortedData, handleSort, sortConfig } = useSortedData(filteredData)

    return {
        sortedData,
        handleSort,
        sortConfig,
        searchQuery,
        setSearchQuery,
    }
}

export type InviteLinksSitesTableProps = {
    groupId: number
    activeSite: Site
    activeAccount: AdvertiserAccount | null
    siteLinks: SiteLinkWithAnalyticsType[]
    isTableLoading: boolean
}
export const InviteLinksSitesTable = ({
    groupId,
    activeSite,
    activeAccount,
    siteLinks,
    isTableLoading,
}: InviteLinksSitesTableProps) => {
    const user = useActiveUser()
    const { skipColumns } = useSkipColumns()
    const markingStatus = useMarkingStatus()
    const { selectedLinksSet, onLinkSelect } = useSiteLinkSelection({
        groupId,
    })
    const { sortConfig, handleSort, searchQuery, setSearchQuery, sortedData } =
        useTableRows(siteLinks)

    const { mutate } = useUpdateSiteLinkMutation({
        groupId,
        siteId: activeSite.site_id,
    })

    const editSingleFieldHook = useEditSingleField()

    return (
        <section className="invite-links-table">
            {isTableLoading && <TableLoadingIndicator />}
            <ScrollableTable
                type="site"
                headRow={
                    <TableHeadRow
                        {...{
                            groupId,
                            activeSite,

                            skipColumns,

                            sortConfig,
                            handleSort,
                            searchQuery,
                            setSearchQuery,
                        }}
                    />
                }
            >
                {sortedData.map((dataRow) => (
                    <TableRow
                        key={dataRow.link_id}
                        data={dataRow}
                        selected={selectedLinksSet.has(dataRow.link_id)}
                        onSelect={onLinkSelect}
                        {...editSingleFieldHook}
                        {...{
                            groupId,
                            skipColumns,
                            mutate,
                            user,
                            activeSite,
                            activeAccount,
                            markingStatus,
                        }}
                    />
                ))}
            </ScrollableTable>
        </section>
    )
}
